import Echo from 'laravel-echo';
import {
  getAuthenticatedWebSocket as pguiGetAuthWebSocket,
  getWebsocket as pguiGetWebSocket,
} from '@practicegenius/pg-ui/src/utils/websocket';
import * as env from '../constants/env';
import {useApi} from '../http/AuthApiProvider';

const coreServiceUrl = env.PG_CORE_URL;

export const getWebsocket = (): Echo => {
  const config = {
    pusherKey: env.PUSHER_KEY,
    pusherCluster: env.PUSHER_CLUSTER,
    pusherHost: env.PUSHER_HOST,
    authEndpoint: `${coreServiceUrl}/global_users/broadcasting/auth`,
  };

  return pguiGetWebSocket(config);
};

export const useGetAuthenticatedWebSocket = () => {
  const {globalUserJwt} = useApi();
  const config = {
    pusherKey: env.PUSHER_KEY,
    pusherCluster: env.PUSHER_CLUSTER,
    pusherHost: env.PUSHER_HOST,
    authEndpoint: `${coreServiceUrl}/global_users/broadcasting/auth`,
  };

  return () => pguiGetAuthWebSocket({token: globalUserJwt, ...config});
};
